"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var ComTableauExtensionsValidationserviceExtensionsValidationResponseStatusEnum;
(function (ComTableauExtensionsValidationserviceExtensionsValidationResponseStatusEnum) {
    ComTableauExtensionsValidationserviceExtensionsValidationResponseStatusEnum["DisabledOnServer"] = "DISABLED_ON_SERVER";
    ComTableauExtensionsValidationserviceExtensionsValidationResponseStatusEnum["BlockedByServer"] = "BLOCKED_BY_SERVER";
    ComTableauExtensionsValidationserviceExtensionsValidationResponseStatusEnum["DisabledOnSite"] = "DISABLED_ON_SITE";
    ComTableauExtensionsValidationserviceExtensionsValidationResponseStatusEnum["NotInSiteSafeList"] = "NOT_IN_SITE_SAFE_LIST";
    ComTableauExtensionsValidationserviceExtensionsValidationResponseStatusEnum["ViolatesSafeListPermission"] = "VIOLATES_SAFE_LIST_PERMISSION";
    ComTableauExtensionsValidationserviceExtensionsValidationResponseStatusEnum["PromptUser"] = "PROMPT_USER";
    ComTableauExtensionsValidationserviceExtensionsValidationResponseStatusEnum["Load"] = "LOAD";
})(ComTableauExtensionsValidationserviceExtensionsValidationResponseStatusEnum = exports.ComTableauExtensionsValidationserviceExtensionsValidationResponseStatusEnum || (exports.ComTableauExtensionsValidationserviceExtensionsValidationResponseStatusEnum = {}));
function ComTableauExtensionsValidationserviceExtensionsValidationResponseFromJSON(json) {
    return ComTableauExtensionsValidationserviceExtensionsValidationResponseFromJSONTyped(json, false);
}
exports.ComTableauExtensionsValidationserviceExtensionsValidationResponseFromJSON = ComTableauExtensionsValidationserviceExtensionsValidationResponseFromJSON;
function ComTableauExtensionsValidationserviceExtensionsValidationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
    };
}
exports.ComTableauExtensionsValidationserviceExtensionsValidationResponseFromJSONTyped = ComTableauExtensionsValidationserviceExtensionsValidationResponseFromJSONTyped;
function ComTableauExtensionsValidationserviceExtensionsValidationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
    };
}
exports.ComTableauExtensionsValidationserviceExtensionsValidationResponseToJSON = ComTableauExtensionsValidationserviceExtensionsValidationResponseToJSON;
